import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CORGI_PERIMETERX_SENSOR_SCRIPT_ENABLED = createFcmDetails(
	'corgi_perimeterx_sensor_script_enabled',
	{
		owner: 'FE framework squad',
		context: 'corgi',
		import: false,
		description: `Used to enable/disable the adding of the perimeterX sensor script in the server-rendered HTML.
		This does not disable the nginx plugin, which can still block requests even if this is disabled.
		For security reasons, this is enabled by default`,
	},
);
